var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"stretch":false,"show-row-numbers":true,"auto-sort-column":3,"auto-sort-reverse":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }